import type { PartnerAdminContractPlan } from '@fukuri-admins/apis/client/gen/model';
import type { ContractPlanDetailHeaderPresentation } from '../../presentations';

type PresentationProps = React.ComponentProps<typeof ContractPlanDetailHeaderPresentation>;

type Args = {
  /** 契約プラン詳細データ */
  contractPlan: PartnerAdminContractPlan;
};

type IConvertToPresentationProps = (args: Args) => Pick<PresentationProps, 'breadcrumbItems'>;

/**
 * API レスポンスを ContractPlanDetailHeader の Presentation Props に変換する
 */
export const convertToPresentationProps: IConvertToPresentationProps = ({ contractPlan }) => ({
  breadcrumbItems: [{ label: '契約プラン', href: '/contract-plans' }, { label: contractPlan.name }],
});
